import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { inputCls, labelCls, Spinner } from "@/components/common/states";
import { useSEO } from "@/lib/seo";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  useSEO({ title: "Admin Login", description: "Endeavour Castle admin login." });

  useEffect(() => { if (user) nav("/admin/dashboard"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      nav("/admin/dashboard");
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-primary p-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <span className="inline-grid place-items-center h-12 w-12 rounded-sm bg-accent text-accent-foreground font-display text-xl mb-3">E</span>
          <h1 className="font-display text-2xl text-white">Endeavour Castle Admin</h1>
          <p className="text-white/60 text-sm mt-1">Sign in to manage properties and leads</p>
        </div>
        <form data-testid="admin-login-form" onSubmit={submit} className="rounded-lg bg-white p-8 space-y-4">
          <div>
            <label className={labelCls} htmlFor="ae">Email</label>
            <Input id="ae" data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} placeholder="you@example.com" />
          </div>
          <div>
            <label className={labelCls} htmlFor="ap">Password</label>
            <Input id="ap" data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} placeholder="••••••••" />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-destructive">{error}</p>}
          <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full h-12 bg-primary text-primary-foreground hover:bg-primary/90 flex items-center justify-center gap-2">
            {loading ? <Spinner /> : <><Lock className="h-4 w-4" aria-hidden /> Sign In</>}
          </Button>
        </form>
      </div>
    </div>
  );
}
